import styled from "styled-components";

export const HeaderContainer = styled.div`
  width: 100%;
  padding: 16px 0;
  top: 0;
  border-bottom: 2px solid var(--bg-gray);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-weight: 500;
  font-size: 16px;
  text-align: right;
  z-index: 100;
  @media (max-width: 1130px) {
    font-size: 14px;
  }
  @media (max-width: 1024px) {
    position: fixed;
    top: 0;
    right: 0;
    background: #ffffff;
    box-shadow: 0px 24px 29px rgba(108, 136, 170, 0.015),
      0px 4.8px 4.7125px rgba(108, 136, 170, 0.03);
    border-radius: 0px 0px 16px 16px;
    height: 52px;
    padding: 0 16px;
    .wallet-info-wrapper {
      /* padding: 0 5px;
       width: 47%; */
      /* background-color: green;
       width: 47%; */
    }
  }
`;

export const WalletInfo = styled.div`
  /* width: 320px; */
  height: 100%;
  border: none;
  display: flex;
  flex: 1;
  justify-content: space-between;
  align-items: center;
  direction: rtl;
  & > div {
    display: flex;
    align-items: center;
  }
  @media (max-width: 1305px) {
    flex: 1.2;
  }
  @media (max-width: 1130px) {
    font-size: 14px;
  }
  @media (max-width: 1200px) {
    margin: 0 5px;
  }

  @media (max-width: 1024px) {
    flex: 0.8;
    margin: 0;
  }
  /* @media (max-width: 768px) {
    flex: 2;
  } */
  @media (max-width: 480px) {
    flex: 2.4;
  }
  /* @media (max-width:1024px) {
    width: 100%;
    justify-content: center;
  } */
`;

export const WalletDiscript = styled.span`
  font-weight: 500;
  font-size: 16px;
  line-height: 28px;
  color: ${(props) => props.color || "#27548C"};
  text-align: right;
  margin-right: 8px;
  @media (max-width: 1024px) {
    display: none;
  }
`;

export const WalletValue = styled.span`
  font-weight: 500;
  font-size: 16px;
  color: ${(props) => props.color || "#27548c"};
  text-align: right;
  margin-right: 8px;
  @media (max-width: 1024px) {
    font-size: 14px;
    margin-right: 0;
  }
`;

export const VerticalLine = styled.div`
  border-left: 2px solid #e9ebf8;
  height: 80%;
  @media (max-width: 360px) {
    display: none;
  }
`;

export const PriceInfo = styled.div`
  font-weight: 500;
  font-size: 16px;
  color: ${(props) => props.color || "#27548c"};
  text-align: right;
  direction: rtl;
  display: flex;
  align-items: center;
  cursor: pointer;
  @media (max-width: 1130px) {
    font-size: 14px;
  }
  @media (max-width: 1200px) {
    margin: 0 5px;
  }
  @media (max-width: 1024px) {
    display: none;
  }
  & .title {
    color: var(--text-500);
    font-size: 16px;
    font-weight: 500;
  }
`;
export const Price = styled.span`
  color: ${(props) => props.color || "#27548C"};
  display: inline-block;
  padding: 0 4px;
`;

export const Recharge = styled.span`
  color: ${(props) => props.color || "#27548c"};
  direction: rtl;
  cursor: pointer;
  @media (max-width: 360px) {
    display: none;
  }
`;

export const SelectAcc = styled.select`
  border: none;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  text-align: right;
  color: #27548c;
  background-color: #fafafa;
`;
export const ProfileContainer = styled.div`
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  justify-items: space-between;
  /* margin: 50px; */
  @media (max-width: 1024px) {
    flex-direction: row;
    /* width: 50%; */
    margin: 0;
  }
  @media (max-width: 500px) {
    margin: unset;
    margin-left: 10px;
  }
`;

export const ProfileDetails = styled.div`
  width: 56px;
  height: 56px;
  border-radius: 50%;
  /* background-image:  */
  margin: 0px 15px;
  img {
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
    border-radius: 50%;
    border: 3px solid ${(props) => props.color || "#27548C"};
  }
  @media (max-width: 1024px) {
    width: 40px;
    height: 40px;
    margin: 0 5px;
    img {
      border-width: 2px;
    }
  }
`;

export const ProfileDropdown = styled.div`
  display: flex;
  width: 130px;
  align-items: flex-end;
  flex-direction: column;
  margin-top: 20px;
  z-index: 50;
  justify-content: space-between;
  /* background-color: #ffffff; */
  padding: 0 5px;
  height: 40px;
  /* &.show{
    height: 70px;
  } */
`;

export const TransactionsReport = styled.div`
  display: flex;
  scale: 0.6;
  margin-right: 8px;
  & button {
    width: 130px !important;
    font-size: 14px;
    @media (max-width: 375px) {
      width: 120px !important;
      font-size: 12px;
      padding: 0 4px !important;
    }
  }
`;

export const ProfileImgWrapper = styled.div`
  img {
    display: block;
    margin-left: 5.25px;
  }
`;
export const PriceInfoContainer = styled.div`
  display: flex;
  align-items: center;
  direction: rtl;
  flex: 2.5;
  @media (max-width: 1024px) {
    flex: 2;
  }
`;

export const ProfileMobileWrapper = styled.div`
  width: 100%;
  display: flex;
  flex: 0;
  align-items: center;
  justify-content: space-between;
  position: relative;
  @media (max-width: 1024px) {
    flex-direction: row-reverse;
  }
`;

export const ProfileIcon = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  margin-right: 14px;
  & svg {
    color: var(--primary-600);
    &.open {
      transform: rotate(180deg);
    }
  }
  @media (max-width: 1024px) {
    margin-right: 0;
  }
`;

export const ProfileName = styled.div`
  color: ${(props) => props.color};
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  margin-left: 40px;
  @media (max-width: 1024px) {
    margin-left: 0;
    margin-right: 20px;
  }
`;

export const ProfileModal = styled.div`
  width: 140px;
  box-shadow: 2px 4px 10px rgba(108, 136, 170, 0.25);
  border-radius: 8px;
  background-color: #ffffff;
  position: absolute;
  top: 78px;
  left: 4%;
  color: #2d3134;
  & > div:last-child:hover {
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
  }
  @media (max-width: 1024px) {
    top: 51px;
    left: 0;
  }
  & a {
    text-decoration: none;
    color: #2d3134;
  }
  & div:nth-of-type(3) {
    border: none;
  }
  & svg {
    width: 21.5px;
    height: 21.5px;
    margin-left: 5.25px;
    display: inline-flex;
    color: var(--primary-600);
  }
  & > div svg {
    color: var(--tertiary-600);
  }
  @media (max-width: 1024px) {
    width: 130px;
  }
  &.hidden {
    display: none;
  }
`;
export const ProfileWrapper = styled.div`
  width: 100%;
  display: flex;
  direction: rtl;
  justify-content: flex-start;
  align-items: center;
  height: 40px;
  padding: 8px;
  border-bottom: 0.5px solid #e9ebf8;
  font-size: 12px;
  color: var(--text-500);
  font-weight: 700;
  cursor: pointer;
  transition: 0.6s;

  &:hover {
    opacity: 0.85;
    background-color: var(--primary-100);
  }
  &:first-child:hover {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }
`;
export const TariffContainer = styled.div`
  background: var(--bg-white);
  box-shadow: 2px 4px 10px rgba(72, 86, 81, 0.15);
  border-radius: 16px;
  padding: 40px 24px;
  position: absolute;
  width: fit-content;
  top: 42px;
  right: 150px;
  & > div {
    color: var(--text-500);
    text-align: right;
    font-size: 16px;
    font-weight: 700;
    margin-bottom: 24px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  & .title {
    color: red;
  }
  & .price {
    color: var(--primary-600);
  }
  &.hidden {
    display: none;
  }
`;
